import { render } from "./xtx-message.vue?vue&type=template&id=3ed2870a&scoped=true"
import script from "./xtx-message.vue?vue&type=script&lang=js"
export * from "./xtx-message.vue?vue&type=script&lang=js"

import "./xtx-message.vue?vue&type=style&index=0&id=3ed2870a&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lhc\\hk-lottery-lhc-ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed2870a"]])

export default __exports__